var map = {
	"app/activities/brainstorming/brainstorming.module": [
		"./src/app/activities/brainstorming/brainstorming.module.ts",
		"common",
		"brainstorming.module"
	],
	"app/activities/participant-questions/participant-questions.module": [
		"./src/app/activities/participant-questions/participant-questions.module.ts",
		"common",
		"participant-questions.module"
	],
	"app/activities/rating/rating.module": [
		"./src/app/activities/rating/rating.module.ts",
		"common",
		"rating.module"
	],
	"app/activities/sorting/sorting.module": [
		"./src/app/activities/sorting/sorting.module.ts",
		"common",
		"sorting.module"
	],
	"app/admin/admin.module": [
		"./src/app/admin/admin.module.ts",
		"common",
		"admin.module"
	],
	"app/analysis/analysis.module": [
		"./src/app/analysis/analysis.module.ts",
		"common",
		"analysis.module"
	],
	"app/auth/auth.module": [
		"./src/app/auth/auth.module.ts",
		"common",
		"auth.module"
	],
	"app/help-center/help-center.module": [
		"./src/app/help-center/help-center.module.ts",
		"common",
		"help-center.module"
	],
	"app/message-center/message-center.module": [
		"./src/app/message-center/message-center.module.ts",
		"common",
		"message-center.module.0"
	],
	"app/my-account/my-account.module": [
		"./src/app/my-account/my-account.module.ts",
		"common",
		"my-account.module.0"
	],
	"app/my-projects/my-projects.module": [
		"./src/app/my-projects/my-projects.module.ts",
		"common",
		"my-projects.module"
	],
	"app/notifications/notifications.module": [
		"./src/app/notifications/notifications.module.ts",
		"common",
		"notifications.module.0"
	],
	"app/offline-data-manager/offline-data-manager.module": [
		"./src/app/offline-data-manager/offline-data-manager.module.ts",
		"common",
		"offline-data-manager.module"
	],
	"app/participants/participants.module": [
		"./src/app/participants/participants.module.ts",
		"common",
		"participants.module"
	],
	"app/project/project.module": [
		"./src/app/project/project.module.ts",
		"common",
		"project.module"
	],
	"app/reports/reports.module": [
		"./src/app/reports/reports.module.ts",
		"common",
		"reports.module"
	],
	"app/review-data/review-data.module": [
		"./src/app/review-data/review-data.module.ts",
		"common",
		"review-data.module"
	],
	"app/staff/accounts/accounts.module": [
		"./src/app/staff/accounts/accounts.module.ts",
		"common",
		"accounts.module"
	],
	"app/staff/dashboard/dashboard.module": [
		"./src/app/staff/dashboard/dashboard.module.ts",
		"common",
		"dashboard.module"
	],
	"app/staff/faqs/faqs.module": [
		"./src/app/staff/faqs/faqs.module.ts",
		"common",
		"faqs.module"
	],
	"app/staff/licenses/licenses.module": [
		"./src/app/staff/licenses/licenses.module.ts",
		"common",
		"licenses.module"
	],
	"app/staff/logs/logs.module": [
		"./src/app/staff/logs/logs.module.ts",
		"common",
		"logs.module"
	],
	"app/staff/message-center/message-center.module": [
		"./src/app/staff/message-center/message-center.module.ts",
		"common",
		"message-center.module"
	],
	"app/staff/migration/migration.module": [
		"./src/app/staff/migration/migration.module.ts",
		"common",
		"migration.module"
	],
	"app/staff/my-account/my-account.module": [
		"./src/app/staff/my-account/my-account.module.ts",
		"common",
		"my-account.module"
	],
	"app/staff/notifications/notifications.module": [
		"./src/app/staff/notifications/notifications.module.ts",
		"common",
		"notifications.module"
	],
	"app/staff/projects/projects.module": [
		"./src/app/staff/projects/projects.module.ts",
		"common",
		"projects.module"
	],
	"app/staff/staff.module": [
		"./src/app/staff/staff.module.ts",
		"common",
		"staff.module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_gendir lazy recursive";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/$$_gendir lazy
// module id = ./src/$$_gendir lazy recursive
// module chunks = main